import useLocalStore from '../../../../hooks/useLocalStore.js';
import { useDispatch, useSelector } from 'react-redux';
import FJImageToImageLeftContainer from '../../../FJImageToImage/FJImageToImageLeft/FJImageToImageLeftContainer.jsx';
import { AI_GENERATOR_PHOTO_TAB_LIST } from '../../../../config/dataConfig/FJAIPhotoGeneratorData.js';
import FJAppConstant from '../../../../constants/FJAppConstant.js';
import FJTextToImageLeftContainer from '../../../FJTextToImage/FJTextToImageLeft/container/FJTextToImageLeftContainer.jsx';
import FJAIPhotoEditorLeftContainer from '../../../FJAIPhotoEditor/left/container/FJAIPhotoEditorLeftContainer.jsx';
import { useEffect } from 'react';
import FJActionAIPhotoGenerator from '../../../../redux/action/FJActionAIPhotoGenerator.js';
import FJUtil from '../../../../util/FJUtil.js';

const FJAIPhotoGeneratorLeftContainer = () => {
    useLocalStore();
    const tabIndex = useSelector(state => state.aiPhotoGenerator.tabIndex);
    const tabType = AI_GENERATOR_PHOTO_TAB_LIST[tabIndex].value;
    const dispatch = useDispatch();

    useEffect(() => {
        if (FJUtil.isEditPage()) {
            return;
        }
        dispatch(FJActionAIPhotoGenerator.initAction());
    }, [dispatch]);

    return (
        <>
            {tabType === FJAppConstant.IMAGE_TO_IMAGE && <FJImageToImageLeftContainer />}
            {tabType === FJAppConstant.TEXT_TO_IMAGE && <FJTextToImageLeftContainer />}
            {tabType === FJAppConstant.AI_PHOTO_EDITOR && <FJAIPhotoEditorLeftContainer />}
        </>
    );
};
export default FJAIPhotoGeneratorLeftContainer;
